<template>
<div :style="{'height':height, 'width': width}" 
    class="row"
    v-if="display && showComponent"
    :key="componentRefresh"
>
    <div class="col-4" v-show="!showOnlyEdit">
        <div class="primary-file-container">
            <img :src="l_primaryFile._src">
        </div>
    </div>
    <div class="col-8" v-show="!showOnlyEdit">
        <ks-file-list
            :ref="`file-list-${_uid}`"
            :defaultViewType="defaultViewType"
            :defaultFilters="defaultFilters"
            @onSet="setPrimaryFile"
            @onEdit="editFile"
            @onRemove="removeFile"
            @onClick="clickFile"
            @onLoadList="loadFileList"
        >
            <template slot="title">
                <ks-text text="UPLOADED FILES - Select a file to use:"/>
            </template>
        </ks-file-list>
    </div>
    
    <div class="col-12">
        <ks-upload-files 
            :ref="`fs-upload-files-${_uid}`"
            style="width: 100%; margin:12px;"
            :uploadOptions="uploadOptions"
            :showDefaultNavigation="showDefaultNavigation"
            @onUpload="uploadFiles"
            @onOpenEdit="verifyFiles"
            @onCloseEdit="verifyFiles"
            @onCancel="verifyFiles"
            @onChange="changeUploadFiles"
            @onChangeMode="uploaderChangeMode"
            @onUploadLoading="uploadLoading"
        />
    </div>
</div>
</template>
    
<script>
import checkPermissions from '../../mixins/checkPermissions';
import getSRCThumbnail from '../../mixins/getSRCThumbnail';

export default {
    name: 'file-selector',
    mixins: [checkPermissions, getSRCThumbnail],
    props: {
        primaryFile:{
            type: Object,
            default : () => {return{campaign_id:null, id:null}}
        },
        defaultViewType:{
            type:String,
            default: 'grid'
        },
        defaultFilters:{
            type: Object,
            required: true
        },
        uploadOptions: {
            type: Object,
            required: true
        },
        height: {
            type: String,
            default: '100%'
        },
        width:{
            type: String,
            default: '100%'
        },
        display: {
            type: Boolean,
            default: true
        },
        showDefaultNavigation:{
            type: Boolean,
            default: true
        }
    },
    watch:{
        primaryFile:{
            handler(){
                this.loadPrimaryFile();
            },
            deep:true
        }
    },
    methods:{
        setPrimaryFile({file}){
            if(this.l_primaryFile.id != file.id){
                this.l_primaryFile = file;
                this.$emit('onChange', {ref:this, file:file});
            }
        },
        editFile(){},
        removeFile(){},
        clickFile({file}){},

        changeUploadFiles(evt){
            this.verifyFiles(evt);
            this.$emit('onChangeUploadFiles', evt);
        },

        verifyFiles({files}){
            if(files.length > 0){
                this.showOnlyEdit = true;
            }else{
                this.showOnlyEdit = false;
            }
        },


        uploadFiles(evt){
            this.$refs[`file-list-${this._uid}`].loadFileList();
        },

        uploaderChangeMode(evt){
            this.$emit('onUploaderChangeMode', evt);
        },

        uploadLoading(evt){
            this.$emit('onUploadLoading', evt);
        },

        loadFileList(){},
        async loadPrimaryFile(){
            if(this.primaryFile._src){
                this.l_primaryFile = this.primaryFile;
            }else if(this.primaryFile.campaign_id && this.primaryFile.id){
                try{
                    let res = await app.data.read('file.file', {"campaign_id":this.primaryFile.campaign_id , "file_id":this.primaryFile.id});
                    let file = res.read[0];
                    this.l_primaryFile = {...file, '_src':`${this.getSRCThumbnail(file, true)}`};
                }catch(err){
                    console.log(err);
                }
            }else{
                this.l_primaryFile = {_src: 'none'};
            }
        },

        /* upload file actions */

        execUpload(){
            this.$refs[`fs-upload-files-${this._uid}`].upload();
        },

        execCloseEdit(){
            this.$refs[`fs-upload-files-${this._uid}`].closeEdit();
        },

        execCancel(){
            this.$refs[`fs-upload-files-${this._uid}`].cancel();
        }

    },
    mounted(){
        this.loadPrimaryFile();
    },
    data(){
        return{
            showOnlyEdit: false,
            l_primaryFile: {_src: 'none'},
        }
    }
}
</script>
        
<style>
    .primary-file-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #e9e9e9;
        min-width: 100%;
        min-height: 30.2dvh;
        max-height: 30.2dvh;
    }

    .primary-file-container img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain; 
    } 
</style>